export interface ISiteSettings {
    outsideEnviromnentViewImageUrl?: string | undefined;
    isPublicSite: boolean;
}
